"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.segmentOptions = void 0;
const materialTypes_1 = require("../types/materialTypes");
exports.segmentOptions = {
    lifestyle: materialTypes_1.Segment.LIFESTYLE,
    performance: materialTypes_1.Segment.PERFORMANCE,
};
